import { render, staticRenderFns } from "./TabelaResultadosCargos.vue?vue&type=template&id=2ef99690&scoped=true&"
import script from "./TabelaResultadosCargos.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosCargos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosCargos.vue?vue&type=style&index=0&id=2ef99690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef99690",
  null
  
)

export default component.exports